const slots=[
    {
        id:1,
        pin:282001,
        location:"Dharmapuri, Forest Colony, Tajganj, Agra, Uttar Pradesh",
        city:"Agra",
        state:"Uttar Pradesh"
    },
    {
        id:2,
        pin:282001,
        location:"Dharmapuri, Forest Colony, Tajganj, Agra, Uttar Pradesh",
        city:"Agra",
        state:"Uttar Pradesh"
    },
    {
        id:3,
        pin:282001,
        location:"Dharmapuri, Forest Colony, Tajganj, Agra, Uttar Pradesh",
        city:"Agra",
        state:"Uttar Pradesh"
    },
    {
        id:4,
        pin:282001,
        location:"Dharmapuri, Forest Colony, Tajganj, Agra, Uttar Pradesh",
        city:"Agra",
        state:"Uttar Pradesh"
    },
]

export {slots};